export default __webpack_public_path__ + "static/media/be-sure-step1.aba417f2.png";